import { render, staticRenderFns } from "./HomeGird.vue?vue&type=template&id=72dc04d8&scoped=true&"
import script from "./HomeGird.vue?vue&type=script&lang=js&"
export * from "./HomeGird.vue?vue&type=script&lang=js&"
import style0 from "./HomeGird.vue?vue&type=style&index=0&id=72dc04d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc04d8",
  null
  
)

/* custom blocks */
import block0 from "./HomeGird.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports